/**
 * Builds the canonical, crawlable flight-results URL:
 *   /flights/<ORIGIN>-<DEST>?departureDate=...&returnDate=...&adults=...
 *
 * Origin/destination live in the path (one stable URL per route); everything
 * else (dates, travelers, cabin) stays in the query string. Shared by HomePage
 * and FlightResultsPage so the path format has a single source of truth.
 */
export function buildFlightPath(params = {}) {
  const { origin, destination } = params
  const childAges = Array.isArray(params.childAges)
    ? params.childAges
        .map((age) => Number(age))
        .filter((age) => Number.isFinite(age) && age >= 2 && age <= 11)
        .join(',')
    : ''

  const entries = {
    departureDate: params.departureDate,
    returnDate: params.returnDate,
    tripType: params.tripType,
    originLabel: params.originLabel,
    destinationLabel: params.destinationLabel,
    originCodeType: params.originCodeType,
    destinationCodeType: params.destinationCodeType,
    adults: params.adults,
    childAges,
    infants: params.infants,
    cabinClass: params.cabinClass,
    currency: params.currency,
  }

  const query = new URLSearchParams()
  Object.entries(entries).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, String(value))
  })

  const qs = query.toString()
  const base = `/flights/${origin}-${destination}`
  return qs ? `${base}?${qs}` : base
}
